import { IGiftboxCreateRequestDto, IGiftboxUpdateRequestDto } from '../types';
import settings from '../settings';
import api from './base';

export function createGiftBox(payload: IGiftboxCreateRequestDto) {
  const uri = `${settings.getApiURI()}/coupon/v1/giftboxes`;
  return api.http.post(uri, payload);
}

export function updateGiftBox(giftboxId: number, payload: IGiftboxUpdateRequestDto) {
  const uri = `${settings.getApiURI()}/coupon/v1/giftboxes/${giftboxId}`;
  return api.http.patch(uri, payload);
}

export function getGiftboxById(giftboxId: number) {
  const uri = `${settings.getApiURI()}/coupon/v1/giftboxes/${giftboxId}`;
  return api.getWithCancel(uri);
}

export function getLiveGiftbox() {
  const uri = `${settings.getApiURI()}/coupon/v1/giftboxes`;
  return api.getWithCancel(uri);
}

export function getScheduledGiftbox() {
  const uri = `${settings.getApiURI()}/coupon/v1/giftboxes/scheduled`;
  return api.getWithCancel(uri);
}

export function getUnscheduledGiftbox() {
  const uri = `${settings.getApiURI()}/coupon/v1/giftboxes/unscheduled`;
  return api.getWithCancel(uri);
}

export function updateGiftboxStartDateById(id: number, startDate: string) {
  const uri = `${settings.getApiURI()}/coupon/v1/giftboxes/${id}/schedule`;
  return api.http.patch(uri, {
    startDate,
  });
}

export function deleteGiftboxById(id: number) {
  const uri = `${settings.getApiURI()}/coupon/v1/giftboxes/${id}`;
  return api.http.delete(uri);
}
